// src/store/marketplaceSuppliersSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const apiKey = "G8js92h02h3j0s0sk2jhsj392slk20s";

const buildQueryParams = ({ page = 1, limit = 10, filters }) => {
  const params = new URLSearchParams();

  params.append("page", page);
  params.append("limit", limit);

  if (filters.Country.length) {
    filters.Country.forEach((c) => params.append("country", c));
  }

  if (filters.City.length) {
    filters.City.forEach((c) => params.append("city", c));
  }

  if (filters.State.length) {
    filters.State.forEach((s) => params.append("state", s));
  }

  if (filters.Industry.length) {
    filters.Industry.forEach((i) => params.append("industry", i));
  }

  if (filters.Certification.length) {
    filters.Certification.forEach((c) =>
      params.append("certificationStatus", c)
    );
  }

  return params.toString();
};

export const fetchFilteredSuppliers = createAsyncThunk(
  "suppliers/fetchFilteredSuppliers",
  async ({ page = 1, limit = 50, filters }, { rejectWithValue }) => {
    try {
      const queryString = buildQueryParams({ page, limit, filters });

      const response = await axios.get(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/v1/suppliers?${queryString}`,
        {
          headers: {
            "x-api-key": apiKey,
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const getMarketplaceSuppliers = createAsyncThunk(
  "marketplaceSuppliers/getAll",
  async ({ filters, page = 1, limit = 50 }, { rejectWithValue }) => {
    try {
      let normalizedFilters = {};

      if (filters) {
        normalizedFilters = Object.entries(filters).reduce(
          (acc, [key, value]) => {

            if (key === "certification") {
              const certValue = Array.isArray(value) ? value[0] : value;

              acc["certificationStatus"] =
                certValue === "Certified"
                  ? true
                  : certValue === "Uncertified"
                  ? false
                  : undefined;
            } else {
              acc[key] = value;
            }

            return acc;
          },
          {}
        );
      }

      const response = await axios.post(
        `https://sourceiq-mgmt-egfdadc2frfxfmbw.eastus-01.azurewebsites.net/api/v1/suppliers?page=${page}&limit=${limit}`,
        // `http://localhost:3006/api/v1/suppliers?page=${page}&limit=${limit}`,
        normalizedFilters,
        {
          headers: {
            "x-api-key": apiKey,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const marketplaceSuppliersSlice = createSlice({
  name: "marketplaceSuppliers",
  initialState: {
    suppliers: [],
    currentPage: 1,
    totalPages: 1,
    totalCount: 0,
    loading: false,
    error: null,
  },
  // reducers: {
  // setSelectedSupplier: (state, action) => {
  //   state.selectedSupplier = action.payload;
  // },
  // clearSelectedSupplier: (state) => {
  //   state.selectedSupplier = null;
  // }
  // },
  extraReducers: (builder) => {
    builder
      .addCase(getMarketplaceSuppliers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getMarketplaceSuppliers.fulfilled, (state, action) => {
        state.loading = false;
        state.suppliers = action.payload?.data.suppliers || [];
        state.currentPage = action.payload?.data.page || 1;
        state.totalPages = action.payload?.data.pagination?.totalPages || 1;
        state.totalCount = action.payload?.data.pagination?.totalItems || 0;
      })
      .addCase(getMarketplaceSuppliers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Failed to fetch suppliers";
      });
  },
});

export const {} = marketplaceSuppliersSlice.actions;

export default marketplaceSuppliersSlice.reducer;
